<template>
  <div class="quote-opener" v-on:click.stop="openQuote" :class="{hidden: visible, bubble: bubble}">
    {{ $nippets.portfolio.hello }}
    <div class="quote-message">
      {{ $nippets.quote.happy }}
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dt: null,
      bubble: false
    }
  },
  mounted () {
    this.dt = window.setTimeout(this.bubbleMe, 13000)
  },
  computed: {
    visible () {
      return (this.$store.state.quote.show)
    }
  },
  methods: {
    openQuote () {
      if(this.dt){
        window.clearInterval(this.dt)
      }
      this.dt = null
      this.$k.openQuote()
    },
    async bubbleMe () {
      this.bubble = true
      await this.$k.waitfor(200)
      this.bubble = false
      await this.$k.waitfor(100)
      this.bubble = true
      await this.$k.waitfor(200)
      this.bubble = false
    }
  }
}
</script>

<style>
.quote-opener{
  position:fixed;
  bottom:20px;
  right:20px;
  padding:10px;
  background-color:#8b6f4b;
  color:#fff;
  transition: all 0.2s ease-in-out;
  z-index:40;
  border-radius:8px;
  cursor:pointer;
  text-align:center;
  transform-origin: bottom right;
}

.quote-opener.hidden{
  opacity:0;
}

.quote-opener:hover{
  transform:scale(1.4);
  box-shadow:0px 0px 12px #f9f9f9;
}

.quote-opener.bubble{
  transition: all 0.1s ease-in-out;
  transform:scale(1.3);
}

.quote-message {
  text-align:center;
  font-size:10px;
  max-width:0;
  display:none;
  opacity:0;
  transition:all 0.2s ease-in-out;
}

.quote-opener:hover .quote-message{
  display:block;
  max-width:140px;
  opacity:1;
}

.quote-opener::after{
  content:"";
  position:absolute;
  width:0;
  height:0;
  border-left:10px solid transparent;
  border-right:10px solid transparent;
  border-top:10px solid #8b6f4b;
  position:absolute;
  right:12px;
  bottom:-8px;
}
</style>